<template>
  <div>
    <Breadcrumb :options="breadcrumb" />

    <div class="fillet">
      <div class="retrieval">
        <!-- 表头设置控件 -->
        <div class="right">
          <TableHeadSelect :config="formCtrlRight" :options="formCtrlRight.options" :inputValue="defaultTh"
            @onChange="onTableSelect" />
        </div>
      </div>
    </div>

    <Table ref="table" :tableData="tableData" :cols="cols" :btns="btns" :page="page" :limit="limit" :total="total" :showTotal="true"
      :getTotal="getTotal" @onSelectionChange="onSelectionChange" @onCurrentChange="onCurrentChange"
      @onSizeChange="onSizeChange" />
  </div>
</template>

<script>
import tableMixin from "../../mixin/table";

export default {
  mixins: [tableMixin],
  data() {
    return {
      baseUrl: 'order',
      getListUrl: 'escortrec',
      breadcrumb: [
        { name: "财务管理", path: "/finance/estimatedProfit" },
        { name: "车队利润表", path: "/finance/estimatedProfit" },
        { name: "当月运单" },
      ],
      cols: [
        { keyName: "order_num", label: "运单编号", minwidth: 120 },
        { keyName: "license", label: "车牌号", minwidth: 120 },
        { keyName: "driver", label: "司机姓名", minwidth: 120 },
        { keyName: "shname", label: "客户名称", minwidth: 120 },
        { keyName: "name", label: "货物名称", minwidth: 120 },
        { keyName: "pricing", label: "计价方式", minwidth: 120 },
        { keyName: "coaddress", label: "装货地址", minwidth: 120 },
        { keyName: "enaddress", label: "卸货地址", minwidth: 120 },
        { ...this.ctrls.ZhuangHuoRiQi, minwidth: 120 },
        { ...this.ctrls.XieHuoRiQi, minwidth: 120 },
        { keyName: "inton", label: "装货量", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "unton", label: "卸货量", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "kuiton", label: "亏吨重量", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "caton", label: "计算量", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "ceton", label: "客担亏吨", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "dtonprice", label: "亏吨单价", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "kuitotal", label: "亏吨金额", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "cprice", label: "公司单价", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "freight", label: "公司运费", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "dprice", label: "司机单价", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "infreight", label: "司机运费", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "total", label: "出车费用", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "additional_fees", label: "附加费用", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "compen", label: "运单补差", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "profit", label: "运单毛利额", align: 'right', className: 'pr30', minwidth: 120 },
      ],
      baseParams: ['month', 'license'],
      getTotalProperty: [
        'caton',
        'inton',
        'unton',
        'untons',
        'kuitotal',
        'message',
        'freight',
        'total',
        'compen',
        'profit',
        'kuiton',
        'kuitotal',
        'infreight',
        'dtotal',
        'additional_fees',
        'compen',
      ],
    };
  },
  methods: {
    dataObjHandler(v) {
      const o = {}
      for (const key in v) {
        if (Object.hasOwnProperty.call(v, key)) {
          if (['ceton'].includes(key)) {
            o[key] = Number(v[key]).toFixed(2);
          } else {
            o[key] = v[key];
          }
        }
      }
      const { pricing_id } = v
      if (pricing_id) {
        if (pricing_id == 5) {
          o.inton = '-'
          o.unton = '-'
        }
      }
      return o
    },
  },
  mounted() {
    this.setQueryParams();
    this.$nextTick(this.getList);
  },
};
</script>

<style lang="less" scoped>
.fillet {
  height: auto;
  margin: 0 auto;
  padding: 0 0 10px;
  border-radius: 5px;
  box-shadow: 0px 0px 10px rgb(0 0 0 / 3%);

  .retrieval {
    height: 52px;
    /* overflow: hidden; */
    margin: 0px 20px;
    font-size: 14px;
    color: #606266;
    // display: flex;
    // justify-content: space-between;
    position: relative;

    .right {
      position: absolute;
      right: 10px;
    }
  }
}
</style>
